import { setInvestorsLoginModalOpen } from 'store/state/app/actions';

// Single entry point for opening the full-screen investor login modal (the login step-machine
// rendered via `InvestorsLoginModal`) from anywhere in the Investors experience (header login CTA,
// logged-out section CTAs, the hood timed/scroll login trap). Returns the action so callers can
// `dispatch(openInvestorsLoginModal())` — works both from useDispatch and mapDispatchToProps.
export const openInvestorsLoginModal = () => setInvestorsLoginModalOpen(true);
